"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.trimAgentDraft = exports.buildAgentPayload = exports.toAgentDraft = exports.buildCommonConfigurationPayload = exports.trimCommonConfigurationDraft = exports.normalizeCommonConfigurationDraft = exports.normalizeAgentSettings = exports.validateUniqueVoiceAgentToolNames = exports.validateVoiceAgentTools = exports.serializeVoiceAgentTool = exports.trimVoiceAgentTool = exports.normalizeCommonToolIds = exports.normalizeVoiceAgentTools = exports.normalizeTool = exports.getToolCallCodeType = exports.getAgentName = exports.getAgentId = exports.normalizeList = exports.getResponseBody = exports.toSnakeCase = exports.mapRowsToParameters = exports.mapParametersToRows = exports.normalizeToolParameters = exports.COMMON_CONFIGURATION_SELECTION = exports.RAG_APP_ID_REGEX = exports.PARAMETER_NAME_REGEX = exports.AGENT_NAME_REGEX = exports.TOOL_NAME_REGEX = exports.DEFAULT_TOOL_PARAMETERS = exports.PARAMETER_TYPE_OPTIONS = exports.INITIAL_CODE = exports.AGENT_ROLE_OPTIONS = exports.QUICK_CODE_MULTI_VOICE_AGENT = exports.toolBehaviorOptions = void 0;
var const_1 = require("@src/containers/CodeNode/utils/const");
exports.toolBehaviorOptions = [
    { id: 'handoff', name: 'Handoff to another agent' },
    {
        id: 'tool_call_quick',
        name: 'Quick Code — Lightweight Python logic. Best for branching logic and bot response generation',
        mode: 'tool_call',
        codeType: 'quick',
    },
    {
        id: 'tool_call_advanced',
        name: 'Advanced Code — Python execution for API calls, integrations, and heavy data processing',
        mode: 'tool_call',
        codeType: 'advanced',
    },
    { id: 'rag', name: 'RAG knowledge lookup' },
];
exports.QUICK_CODE_MULTI_VOICE_AGENT = "def run(**kwargs) -> dict:\n    return {\n        \"format\": False,\n        \"response\": \"\",\n        \"next_agent\": \"\",\n        \"disconnect_call\": False,\n        \"parameters\": {},\n    }";
exports.AGENT_ROLE_OPTIONS = [
    { id: 'specialist', name: 'Task-specific Agent' },
    { id: 'orchestrator', name: 'Orchestrator Agent' },
    { id: 'faq', name: 'FAQ agent' },
    { id: 'tool_caller', name: 'Tool-only Agent' },
];
exports.INITIAL_CODE = 'def run(**kwargs) -> dict:\n    return {"format": False, "response": "", "next_agent": ""}';
exports.PARAMETER_TYPE_OPTIONS = [
    { id: 'string', name: 'string' },
    { id: 'number', name: 'number' },
    { id: 'integer', name: 'integer' },
    { id: 'boolean', name: 'boolean' },
    { id: 'array', name: 'array' },
    { id: 'object', name: 'object' },
];
exports.DEFAULT_TOOL_PARAMETERS = {
    type: 'object',
    properties: {},
    required: [],
    additionalProperties: false,
};
exports.TOOL_NAME_REGEX = /^[A-Za-z0-9_]+$/;
exports.AGENT_NAME_REGEX = /^[A-Za-z0-9_ ]+$/;
exports.PARAMETER_NAME_REGEX = /^[A-Za-z0-9_]+$/;
exports.RAG_APP_ID_REGEX = /^[A-Za-z0-9_-]+$/;
exports.COMMON_CONFIGURATION_SELECTION = 'common';
exports.normalizeToolParameters = function (parameters) {
    var _a;
    if (!parameters || typeof parameters !== 'object') {
        return __assign({}, exports.DEFAULT_TOOL_PARAMETERS);
    }
    return {
        type: (_a = parameters === null || parameters === void 0 ? void 0 : parameters.type) !== null && _a !== void 0 ? _a : 'object',
        properties: (parameters === null || parameters === void 0 ? void 0 : parameters.properties) && typeof parameters.properties === 'object'
            ? parameters.properties
            : {},
        required: Array.isArray(parameters === null || parameters === void 0 ? void 0 : parameters.required) ? parameters.required : [],
        additionalProperties: typeof (parameters === null || parameters === void 0 ? void 0 : parameters.additionalProperties) === 'boolean'
            ? parameters.additionalProperties
            : false,
    };
};
exports.mapParametersToRows = function (parameters) {
    var normalized = exports.normalizeToolParameters(parameters);
    var requiredSet = new Set(normalized.required);
    var propertyNames = Object.keys(normalized.properties || {});
    return propertyNames.map(function (propertyName, index) {
        var _a, _b;
        var propertyData = normalized.properties[propertyName] || {};
        var enumValues = Array.isArray(propertyData["enum"])
            ? propertyData["enum"].join(', ')
            : '';
        return {
            rowId: "param-" + (propertyName || 'empty') + "-" + index,
            name: propertyName,
            type: (_a = propertyData.type) !== null && _a !== void 0 ? _a : 'string',
            description: (_b = propertyData.description) !== null && _b !== void 0 ? _b : '',
            enumValues: enumValues,
            required: requiredSet.has(propertyName),
        };
    });
};
exports.mapRowsToParameters = function (rows) {
    var properties = {};
    var required = [];
    rows.forEach(function (row) {
        var fieldName = ((row === null || row === void 0 ? void 0 : row.name) || '').trim();
        var propertySchema = {
            type: (row === null || row === void 0 ? void 0 : row.type) || 'string',
        };
        var description = ((row === null || row === void 0 ? void 0 : row.description) || '').trim();
        if (description) {
            propertySchema.description = description;
        }
        var enumList = ((row === null || row === void 0 ? void 0 : row.enumValues) || '')
            .split(',')
            .map(function (value) { return value.trim(); })
            .filter(Boolean);
        if (enumList.length) {
            propertySchema["enum"] = enumList;
        }
        properties[fieldName] = propertySchema;
        if (row === null || row === void 0 ? void 0 : row.required) {
            required.push(fieldName);
        }
    });
    return {
        type: 'object',
        properties: properties,
        required: required,
        additionalProperties: false,
    };
};
exports.toSnakeCase = function (value) {
    if (value === void 0) { value = ''; }
    return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
};
exports.getResponseBody = function (response) { var _a, _b, _c; return (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : response) !== null && _c !== void 0 ? _c : {}; };
exports.normalizeList = function (data) {
    if (Array.isArray(data))
        return data;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.agents))
        return data.agents;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.results))
        return data.results;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.data))
        return data.data;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.models))
        return data.models;
    return [];
};
exports.getAgentId = function (agent) { var _a, _b; return (_b = (_a = agent === null || agent === void 0 ? void 0 : agent.id) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent['agent_id']) !== null && _b !== void 0 ? _b : agent === null || agent === void 0 ? void 0 : agent.agentId; };
exports.getAgentName = function (agent, index) {
    return (agent === null || agent === void 0 ? void 0 : agent.name) || (agent === null || agent === void 0 ? void 0 : agent.title) || (agent === null || agent === void 0 ? void 0 : agent['display_name']) ||
        "Agent " + (index + 1);
};
exports.getToolCallCodeType = function (tool) {
    var _a, _b, _c;
    var explicitType = ((_b = (_a = tool === null || tool === void 0 ? void 0 : tool.codeType) !== null && _a !== void 0 ? _a : tool === null || tool === void 0 ? void 0 : tool['code_type']) !== null && _b !== void 0 ? _b : '')
        .toString()
        .trim()
        .toLowerCase();
    if (explicitType === 'quick' || explicitType === 'advanced') {
        return explicitType;
    }
    if ((_c = ((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || (tool === null || tool === void 0 ? void 0 : tool['lambda_function_name']) || (tool === null || tool === void 0 ? void 0 : tool['function_name']))) === null || _c === void 0 ? void 0 : _c.toString().trim()) {
        return 'advanced';
    }
    return 'quick';
};
exports.normalizeTool = function (tool) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var mode = (_a = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _a !== void 0 ? _a : '';
    var toolId = (_d = (_c = (_b = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _b !== void 0 ? _b : tool === null || tool === void 0 ? void 0 : tool['tool_id']) !== null && _c !== void 0 ? _c : tool === null || tool === void 0 ? void 0 : tool['common_tool_id']) !== null && _d !== void 0 ? _d : null;
    var nextAgentValue = (_g = (_f = (_e = tool === null || tool === void 0 ? void 0 : tool.nextAgent) !== null && _e !== void 0 ? _e : tool === null || tool === void 0 ? void 0 : tool['target_agent']) !== null && _f !== void 0 ? _f : tool === null || tool === void 0 ? void 0 : tool['next_agent']) !== null && _g !== void 0 ? _g : '';
    if (mode === 'tool_call') {
        return {
            id: toolId,
            isNew: Boolean((tool === null || tool === void 0 ? void 0 : tool.isNew) || toolId === null || toolId === undefined),
            mode: mode,
            description: (_h = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _h !== void 0 ? _h : '',
            name: (_k = (_j = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _j !== void 0 ? _j : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _k !== void 0 ? _k : '',
            parameters: exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters),
            requiresAck: Boolean((_m = (_l = tool === null || tool === void 0 ? void 0 : tool.requiresAck) !== null && _l !== void 0 ? _l : tool === null || tool === void 0 ? void 0 : tool['requires_ack']) !== null && _m !== void 0 ? _m : false),
            code: (tool === null || tool === void 0 ? void 0 : tool.custom_code_block) || (tool === null || tool === void 0 ? void 0 : tool.code) || (tool === null || tool === void 0 ? void 0 : tool['custom_code_block']) ||
                const_1.INIT_CODE_MULTI_VOICE_AGENT,
            codeType: exports.getToolCallCodeType(tool),
            lambdaFunctionName: (tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || (tool === null || tool === void 0 ? void 0 : tool['lambda_function_name']) || (tool === null || tool === void 0 ? void 0 : tool['function_name']) ||
                '',
        };
    }
    if (mode === 'handoff') {
        return {
            id: toolId,
            mode: mode,
            description: (_o = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _o !== void 0 ? _o : '',
            nextAgent: (nextAgentValue || '').toString().trim(),
            name: (_q = (_p = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _p !== void 0 ? _p : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _q !== void 0 ? _q : '',
        };
    }
    if (mode === 'rag') {
        return {
            id: toolId,
            mode: mode,
            description: (_r = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _r !== void 0 ? _r : '',
            name: (_t = (_s = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _s !== void 0 ? _s : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _t !== void 0 ? _t : '',
            requiresAck: Boolean((_v = (_u = tool === null || tool === void 0 ? void 0 : tool.requiresAck) !== null && _u !== void 0 ? _u : tool === null || tool === void 0 ? void 0 : tool['requires_ack']) !== null && _v !== void 0 ? _v : false),
            appId: (_x = (_w = tool === null || tool === void 0 ? void 0 : tool.appId) !== null && _w !== void 0 ? _w : tool === null || tool === void 0 ? void 0 : tool['app_id']) !== null && _x !== void 0 ? _x : '',
            prompt: (_y = tool === null || tool === void 0 ? void 0 : tool.prompt) !== null && _y !== void 0 ? _y : '',
            languageSpecificPrompt: (_0 = (_z = tool === null || tool === void 0 ? void 0 : tool.languageSpecificPrompt) !== null && _z !== void 0 ? _z : tool === null || tool === void 0 ? void 0 : tool['language_specific_prompt']) !== null && _0 !== void 0 ? _0 : {},
        };
    }
    return {
        id: toolId,
        isNew: Boolean((tool === null || tool === void 0 ? void 0 : tool.isNew) || toolId === null || toolId === undefined),
        mode: mode,
        description: (_1 = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _1 !== void 0 ? _1 : '',
        name: (_3 = (_2 = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _2 !== void 0 ? _2 : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _3 !== void 0 ? _3 : '',
        requiresAck: Boolean((_5 = (_4 = tool === null || tool === void 0 ? void 0 : tool.requiresAck) !== null && _4 !== void 0 ? _4 : tool === null || tool === void 0 ? void 0 : tool['requires_ack']) !== null && _5 !== void 0 ? _5 : false),
    };
};
exports.normalizeVoiceAgentTools = function (tools) {
    return Array.isArray(tools) ? tools.map(exports.normalizeTool) : [];
};
exports.normalizeCommonToolIds = function (toolIds) {
    return Array.isArray(toolIds)
        ? Array.from(toolIds
            .reduce(function (acc, toolId) {
            if (toolId === null || toolId === undefined)
                return acc;
            var normalizedKey = String(toolId);
            if (!acc.has(normalizedKey)) {
                acc.set(normalizedKey, toolId);
            }
            return acc;
        }, new Map())
            .values())
        : [];
};
exports.trimVoiceAgentTool = function (tool) {
    var normalizedParameters = exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters);
    var trimmedProperties = Object.entries((normalizedParameters === null || normalizedParameters === void 0 ? void 0 : normalizedParameters.properties) || {}).reduce(function (acc, _a) {
        var propertyName = _a[0], propertySchema = _a[1];
        var trimmedPropertyName = (propertyName || '').toString().trim();
        acc[trimmedPropertyName] = __assign(__assign({}, (propertySchema || {})), { type: propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.type, description: ((propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.description) || '').toString().trim() });
        return acc;
    }, {});
    var trimmedRequired = Array.isArray(normalizedParameters === null || normalizedParameters === void 0 ? void 0 : normalizedParameters.required)
        ? normalizedParameters.required
            .map(function (item) { return (item || '').toString().trim(); })
            .filter(Boolean)
        : [];
    return __assign(__assign({}, (tool || {})), { name: ((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim(), description: ((tool === null || tool === void 0 ? void 0 : tool.description) || '').toString().trim(), nextAgent: tool === null || tool === void 0 ? void 0 : tool.nextAgent, appId: ((tool === null || tool === void 0 ? void 0 : tool.appId) || '').toString().trim(), prompt: ((tool === null || tool === void 0 ? void 0 : tool.prompt) || '').toString().trim(), lambdaFunctionName: ((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || '').toString().trim(), languageSpecificPrompt: Object.entries((tool === null || tool === void 0 ? void 0 : tool.languageSpecificPrompt) || {}).reduce(function (acc, _a) {
            var languageCode = _a[0], promptValue = _a[1];
            acc[languageCode] =
                typeof promptValue === 'string' ? promptValue.trim() : promptValue;
            return acc;
        }, {}), parameters: __assign(__assign({}, normalizedParameters), { properties: trimmedProperties, required: trimmedRequired }) });
};
exports.serializeVoiceAgentTool = function (tool) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var toolMode = (_a = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _a !== void 0 ? _a : '';
    var lambdaFunctionNameKey = 'lambda_function_name';
    var baseToolPayload = {
        id: (_b = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _b !== void 0 ? _b : null,
        mode: toolMode,
        description: (_c = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _c !== void 0 ? _c : '',
        name: (_d = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _d !== void 0 ? _d : '',
    };
    if (toolMode === 'handoff') {
        baseToolPayload.target_agent = (_e = tool === null || tool === void 0 ? void 0 : tool.nextAgent) !== null && _e !== void 0 ? _e : null;
    }
    if (toolMode !== 'handoff') {
        baseToolPayload.requires_ack = Boolean(tool === null || tool === void 0 ? void 0 : tool.requiresAck);
    }
    if (toolMode === 'tool_call') {
        baseToolPayload.parameters = exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters);
        baseToolPayload.code = (_f = tool === null || tool === void 0 ? void 0 : tool.code) !== null && _f !== void 0 ? _f : const_1.INIT_CODE_MULTI_VOICE_AGENT;
        if (exports.getToolCallCodeType(tool) !== 'quick' &&
            ((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || '').toString().trim()) {
            baseToolPayload[lambdaFunctionNameKey] = tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName;
        }
    }
    if (toolMode === 'rag') {
        baseToolPayload.app_id = (_g = tool === null || tool === void 0 ? void 0 : tool.appId) !== null && _g !== void 0 ? _g : '';
        baseToolPayload.prompt = (_h = tool === null || tool === void 0 ? void 0 : tool.prompt) !== null && _h !== void 0 ? _h : '';
        baseToolPayload.language_specific_prompt = (_j = tool === null || tool === void 0 ? void 0 : tool.languageSpecificPrompt) !== null && _j !== void 0 ? _j : {};
    }
    return baseToolPayload;
};
exports.validateVoiceAgentTools = function (tools) {
    var draftTools = Array.isArray(tools) ? tools : [];
    var missingBehaviorIndex = draftTools.findIndex(function (tool) { return !((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim(); });
    if (missingBehaviorIndex !== -1) {
        return {
            toolIndex: missingBehaviorIndex,
            message: 'Tool behavior is required.',
        };
    }
    var missingNameIndex = draftTools.findIndex(function (tool) { return !((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim(); });
    if (missingNameIndex !== -1) {
        return {
            toolIndex: missingNameIndex,
            message: 'Tool name is required.',
        };
    }
    var invalidToolNameIndex = draftTools.findIndex(function (tool) { return !exports.TOOL_NAME_REGEX.test(((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim() || ''); });
    if (invalidToolNameIndex !== -1) {
        return {
            toolIndex: invalidToolNameIndex,
            message: 'Tool name can only contain letters, numbers and underscore.',
        };
    }
    var missingDescriptionIndex = draftTools.findIndex(function (tool) { return !((tool === null || tool === void 0 ? void 0 : tool.description) || '').toString().trim(); });
    if (missingDescriptionIndex !== -1) {
        return {
            toolIndex: missingDescriptionIndex,
            message: 'Tool description is required.',
        };
    }
    var missingNextAgentIndex = draftTools.findIndex(function (tool) {
        return ((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() === 'handoff' &&
            !((tool === null || tool === void 0 ? void 0 : tool.nextAgent) || '').toString().trim();
    });
    if (missingNextAgentIndex !== -1) {
        return {
            toolIndex: missingNextAgentIndex,
            message: 'Next agent is required for handoff.',
        };
    }
    var invalidRagTool = draftTools.reduce(function (acc, tool, toolIndex) {
        if (acc)
            return acc;
        if (((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() !== 'rag')
            return null;
        if (!((tool === null || tool === void 0 ? void 0 : tool.appId) || '').toString().trim()) {
            return {
                toolIndex: toolIndex,
                message: 'RAG App ID is required.',
            };
        }
        if (!exports.RAG_APP_ID_REGEX.test(((tool === null || tool === void 0 ? void 0 : tool.appId) || '').toString().trim())) {
            return {
                toolIndex: toolIndex,
                message: 'RAG App ID can only contain letters, numbers, underscore and hyphen.',
            };
        }
        if (!((tool === null || tool === void 0 ? void 0 : tool.prompt) || '').toString().trim()) {
            return {
                toolIndex: toolIndex,
                message: 'RAG Prompt is required.',
            };
        }
        return null;
    }, null);
    if (invalidRagTool) {
        return invalidRagTool;
    }
    var invalidToolCallParameter = draftTools.reduce(function (acc, tool, toolIndex) {
        if (acc)
            return acc;
        if (((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() !== 'tool_call')
            return null;
        var normalizedParameters = exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters);
        var parameterEntries = Object.entries((normalizedParameters === null || normalizedParameters === void 0 ? void 0 : normalizedParameters.properties) || {});
        for (var parameterIndex = 0; parameterIndex < parameterEntries.length; parameterIndex += 1) {
            var _a = parameterEntries[parameterIndex], parameterName = _a[0], parameterSchema = _a[1];
            var trimmedParameterName = (parameterName || '').toString().trim();
            var trimmedParameterType = ((parameterSchema === null || parameterSchema === void 0 ? void 0 : parameterSchema.type) || '')
                .toString()
                .trim();
            var trimmedParameterDescription = ((parameterSchema === null || parameterSchema === void 0 ? void 0 : parameterSchema.description) || '')
                .toString()
                .trim();
            if (!trimmedParameterName) {
                return {
                    toolIndex: toolIndex,
                    parameterIndex: parameterIndex,
                    field: 'name',
                };
            }
            if (!exports.PARAMETER_NAME_REGEX.test(trimmedParameterName)) {
                return {
                    toolIndex: toolIndex,
                    parameterIndex: parameterIndex,
                    field: 'name_format',
                };
            }
            if (!trimmedParameterType) {
                return {
                    toolIndex: toolIndex,
                    parameterIndex: parameterIndex,
                    field: 'type',
                };
            }
            if (!trimmedParameterDescription) {
                return {
                    toolIndex: toolIndex,
                    parameterIndex: parameterIndex,
                    field: 'description',
                };
            }
        }
        return null;
    }, null);
    if (invalidToolCallParameter) {
        return invalidToolCallParameter;
    }
    var normalizedToolNames = draftTools.map(function (tool) {
        return ((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim().toLowerCase();
    });
    var duplicateToolName = normalizedToolNames.find(function (name, index) { return name && normalizedToolNames.indexOf(name) !== index; });
    if (duplicateToolName) {
        return {
            message: "Tool name \"" + duplicateToolName + "\" already exists. Please use a unique tool name.",
        };
    }
    return null;
};
exports.validateUniqueVoiceAgentToolNames = function (tools, referenceTools, options) {
    var _a;
    if (tools === void 0) { tools = []; }
    if (referenceTools === void 0) { referenceTools = []; }
    if (options === void 0) { options = {}; }
    var draftTools = Array.isArray(tools) ? tools : [];
    var normalizedReferenceNames = new Set(referenceTools
        .map(function (tool) { return ((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim().toLowerCase(); })
        .filter(Boolean));
    var seenDraftNames = new Map();
    var currentScopeLabel = (options === null || options === void 0 ? void 0 : options.currentScopeLabel) || 'this tool list';
    var referenceScopeLabel = (options === null || options === void 0 ? void 0 : options.referenceScopeLabel) || 'the reference list';
    for (var toolIndex = 0; toolIndex < draftTools.length; toolIndex += 1) {
        var toolName = (((_a = draftTools[toolIndex]) === null || _a === void 0 ? void 0 : _a.name) || '')
            .toString()
            .trim()
            .toLowerCase();
        if (toolName) {
            if (seenDraftNames.has(toolName)) {
                return {
                    toolIndex: toolIndex,
                    message: "Tool name must be unique within " + currentScopeLabel + ".",
                };
            }
            if (normalizedReferenceNames.has(toolName)) {
                return {
                    toolIndex: toolIndex,
                    message: "Tool name \"" + toolName + "\" is already used in " + referenceScopeLabel + ".",
                };
            }
            seenDraftNames.set(toolName, toolIndex);
        }
    }
    return null;
};
exports.normalizeAgentSettings = function (agentSettings) {
    if (!agentSettings || typeof agentSettings !== 'object') {
        return {};
    }
    if (Array.isArray(agentSettings)) {
        return {};
    }
    return __assign({}, agentSettings);
};
/* eslint-disable camelcase, dot-notation, no-useless-computed-key */
exports.normalizeCommonConfigurationDraft = function (domainData) {
    var _a, _b, _c, _d, _e, _f, _g;
    return ({
        systemPrompt: (_c = (_b = (_a = domainData === null || domainData === void 0 ? void 0 : domainData['bot_settings']) === null || _a === void 0 ? void 0 : _a['common_system_prompt']) !== null && _b !== void 0 ? _b : domainData === null || domainData === void 0 ? void 0 : domainData.common_system_prompt) !== null && _c !== void 0 ? _c : '',
        guardrails: (_f = (_e = (_d = domainData === null || domainData === void 0 ? void 0 : domainData['bot_settings']) === null || _d === void 0 ? void 0 : _d['common_guardrails']) !== null && _e !== void 0 ? _e : domainData === null || domainData === void 0 ? void 0 : domainData.common_guardrails) !== null && _f !== void 0 ? _f : '',
        tools: exports.normalizeVoiceAgentTools(Array.isArray(domainData === null || domainData === void 0 ? void 0 : domainData['common_tools'])
            ? domainData['common_tools']
            : (_g = domainData === null || domainData === void 0 ? void 0 : domainData['bot_settings']) === null || _g === void 0 ? void 0 : _g['common_tools']),
    });
};
exports.trimCommonConfigurationDraft = function (commonDraft) { return (__assign(__assign({}, (commonDraft || {})), { systemPrompt: ((commonDraft === null || commonDraft === void 0 ? void 0 : commonDraft.systemPrompt) || '').toString().trim(), guardrails: ((commonDraft === null || commonDraft === void 0 ? void 0 : commonDraft.guardrails) || '').toString().trim(), tools: Array.isArray(commonDraft === null || commonDraft === void 0 ? void 0 : commonDraft.tools)
        ? commonDraft.tools.map(exports.trimVoiceAgentTool)
        : [] })); };
var omitUndefinedDeep = function (value) {
    if (Array.isArray(value)) {
        return value.map(omitUndefinedDeep);
    }
    if (value && typeof value === 'object') {
        return Object.entries(value).reduce(function (acc, _a) {
            var key = _a[0], itemValue = _a[1];
            if (itemValue !== undefined) {
                acc[key] = omitUndefinedDeep(itemValue);
            }
            return acc;
        }, {});
    }
    return value;
};
var normalizeVoiceConfigPayload = function (domainData) {
    var voiceConfig = domainData === null || domainData === void 0 ? void 0 : domainData.voice_config;
    if (!voiceConfig ||
        typeof voiceConfig !== 'object' ||
        Array.isArray(voiceConfig)) {
        return {};
    }
    return omitUndefinedDeep(__assign({}, voiceConfig));
};
var normalizeBotPropertiesPayload = function (domainData) {
    var botProperties = domainData === null || domainData === void 0 ? void 0 : domainData.bot_properties;
    if (!botProperties ||
        typeof botProperties !== 'object' ||
        Array.isArray(botProperties)) {
        return {};
    }
    return omitUndefinedDeep(__assign({}, botProperties));
};
var normalizeHybridLanguagesPayload = function (domainData) {
    var hybridLanguages = domainData === null || domainData === void 0 ? void 0 : domainData.hybrid_languages;
    if (!hybridLanguages ||
        typeof hybridLanguages !== 'object' ||
        Array.isArray(hybridLanguages)) {
        return {};
    }
    return omitUndefinedDeep(__assign({}, hybridLanguages));
};
exports.buildCommonConfigurationPayload = function (domainData, commonDraft) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var trimmedDraft = exports.trimCommonConfigurationDraft(commonDraft);
    var supportedLanguages = (_a = domainData === null || domainData === void 0 ? void 0 : domainData.supported_languages) !== null && _a !== void 0 ? _a : [];
    return omitUndefinedDeep({
        domain_id: (_b = domainData === null || domainData === void 0 ? void 0 : domainData.domain_id) !== null && _b !== void 0 ? _b : domainData === null || domainData === void 0 ? void 0 : domainData.id,
        domain_name: (_d = (_c = domainData === null || domainData === void 0 ? void 0 : domainData.domain_name) !== null && _c !== void 0 ? _c : domainData === null || domainData === void 0 ? void 0 : domainData.title) !== null && _d !== void 0 ? _d : domainData === null || domainData === void 0 ? void 0 : domainData.domainName,
        partner_name: (_e = domainData === null || domainData === void 0 ? void 0 : domainData.client) !== null && _e !== void 0 ? _e : domainData === null || domainData === void 0 ? void 0 : domainData.partner_name,
        business_name: (_f = domainData === null || domainData === void 0 ? void 0 : domainData.business_name) !== null && _f !== void 0 ? _f : domainData === null || domainData === void 0 ? void 0 : domainData.test_business,
        active: domainData === null || domainData === void 0 ? void 0 : domainData.active,
        description: domainData === null || domainData === void 0 ? void 0 : domainData.description,
        integration_config: domainData === null || domainData === void 0 ? void 0 : domainData.integration_config,
        response_format: domainData === null || domainData === void 0 ? void 0 : domainData.response_format,
        ai_agent_auth_enabled: domainData === null || domainData === void 0 ? void 0 : domainData.ai_agent_auth_enabled,
        detect_language_for_all_messages: domainData === null || domainData === void 0 ? void 0 : domainData.detect_language_for_all_messages,
        clear_context_on_chat_completion: domainData === null || domainData === void 0 ? void 0 : domainData.clear_context_on_chat_completion,
        ai_agent_session_timeout: domainData === null || domainData === void 0 ? void 0 : domainData.ai_agent_session_timeout,
        ai_agent_session_timeout_enabled: domainData === null || domainData === void 0 ? void 0 : domainData.ai_agent_session_timeout_enabled,
        add_date_and_time_in_prompt: domainData === null || domainData === void 0 ? void 0 : domainData.add_date_and_time_in_prompt,
        voice_enabled: domainData === null || domainData === void 0 ? void 0 : domainData.voice_enabled,
        telephony_platform: domainData === null || domainData === void 0 ? void 0 : domainData.telephony_platform,
        voice_model_id: domainData === null || domainData === void 0 ? void 0 : domainData.voice_model_id,
        tts_enabled: domainData === null || domainData === void 0 ? void 0 : domainData.tts_enabled,
        phone_number: domainData === null || domainData === void 0 ? void 0 : domainData.phone_number,
        voice_config: normalizeVoiceConfigPayload(domainData),
        bot_properties: normalizeBotPropertiesPayload(domainData),
        hybrid_languages: normalizeHybridLanguagesPayload(domainData),
        supported_languages: Array.isArray(supportedLanguages)
            ? supportedLanguages
            : [],
        bot_settings: __assign(__assign({}, ((domainData === null || domainData === void 0 ? void 0 : domainData.bot_settings) || {})), { common_system_prompt: trimmedDraft.systemPrompt, common_guardrails: trimmedDraft.guardrails }),
        via_name: (_h = (_g = domainData === null || domainData === void 0 ? void 0 : domainData.via_name) !== null && _g !== void 0 ? _g : domainData === null || domainData === void 0 ? void 0 : domainData.test_business) !== null && _h !== void 0 ? _h : domainData === null || domainData === void 0 ? void 0 : domainData.business_via_name,
        common_tools: Array.isArray(trimmedDraft.tools)
            ? trimmedDraft.tools.map(exports.serializeVoiceAgentTool)
            : [],
    });
};
/* eslint-enable camelcase, dot-notation, no-useless-computed-key */
exports.toAgentDraft = function (agent) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    var tools = [];
    var toolConfig = agent === null || agent === void 0 ? void 0 : agent['tool_config'];
    if (Array.isArray(agent === null || agent === void 0 ? void 0 : agent.tools)) {
        tools = agent.tools;
    }
    else if (Array.isArray(toolConfig)) {
        tools = toolConfig;
    }
    return {
        id: exports.getAgentId(agent),
        name: (_b = (_a = agent === null || agent === void 0 ? void 0 : agent.name) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent.title) !== null && _b !== void 0 ? _b : '',
        description: (_c = agent === null || agent === void 0 ? void 0 : agent.description) !== null && _c !== void 0 ? _c : '',
        modelProvider: (_j = (_h = (_f = (_e = (_d = agent === null || agent === void 0 ? void 0 : agent['llm_provider']) !== null && _d !== void 0 ? _d : agent === null || agent === void 0 ? void 0 : agent['model_provider']) !== null && _e !== void 0 ? _e : agent === null || agent === void 0 ? void 0 : agent.provider) !== null && _f !== void 0 ? _f : (_g = agent === null || agent === void 0 ? void 0 : agent.model) === null || _g === void 0 ? void 0 : _g.provider) !== null && _h !== void 0 ? _h : agent === null || agent === void 0 ? void 0 : agent['llm_provider']) !== null && _j !== void 0 ? _j : '',
        model: (_o = (_m = (_l = (_k = agent === null || agent === void 0 ? void 0 : agent['llm_model']) !== null && _k !== void 0 ? _k : agent === null || agent === void 0 ? void 0 : agent.model) !== null && _l !== void 0 ? _l : agent === null || agent === void 0 ? void 0 : agent['model_id']) !== null && _m !== void 0 ? _m : agent === null || agent === void 0 ? void 0 : agent['model_name']) !== null && _o !== void 0 ? _o : '',
        role: (_p = agent === null || agent === void 0 ? void 0 : agent.role) !== null && _p !== void 0 ? _p : 'specialist',
        languageSpecificInstructions: (_q = agent === null || agent === void 0 ? void 0 : agent['language_specific_instructions']) !== null && _q !== void 0 ? _q : {},
        deletedToolIds: Array.isArray(agent === null || agent === void 0 ? void 0 : agent['deleted_tool_ids'])
            ? agent === null || agent === void 0 ? void 0 : agent['deleted_tool_ids'] : [],
        isDefault: Boolean((_s = (_r = agent === null || agent === void 0 ? void 0 : agent['is_default']) !== null && _r !== void 0 ? _r : agent === null || agent === void 0 ? void 0 : agent['default_agent']) !== null && _s !== void 0 ? _s : false),
        enableDateTimeContext: Boolean((_v = (_u = (_t = agent === null || agent === void 0 ? void 0 : agent['date_time_context_enabled']) !== null && _t !== void 0 ? _t : agent === null || agent === void 0 ? void 0 : agent['enable_datetime_context']) !== null && _u !== void 0 ? _u : agent === null || agent === void 0 ? void 0 : agent['enable_datetime_context_for_agent']) !== null && _v !== void 0 ? _v : false),
        commonPrompt: (_x = (_w = agent === null || agent === void 0 ? void 0 : agent['common_prompt']) !== null && _w !== void 0 ? _w : agent === null || agent === void 0 ? void 0 : agent.prompt) !== null && _x !== void 0 ? _x : '',
        instructions: (_z = (_y = agent === null || agent === void 0 ? void 0 : agent.instructions) !== null && _y !== void 0 ? _y : agent === null || agent === void 0 ? void 0 : agent['text_instructions']) !== null && _z !== void 0 ? _z : '',
        commonGuardrails: (_1 = (_0 = agent === null || agent === void 0 ? void 0 : agent['common_guardrails']) !== null && _0 !== void 0 ? _0 : agent === null || agent === void 0 ? void 0 : agent.guardrails) !== null && _1 !== void 0 ? _1 : '',
        commonToolIds: exports.normalizeCommonToolIds((_2 = agent === null || agent === void 0 ? void 0 : agent['common_tool_ids']) !== null && _2 !== void 0 ? _2 : agent === null || agent === void 0 ? void 0 : agent.commonToolIds),
        agentSettings: exports.normalizeAgentSettings((_3 = agent === null || agent === void 0 ? void 0 : agent['agent_settings']) !== null && _3 !== void 0 ? _3 : agent === null || agent === void 0 ? void 0 : agent.agentSettings),
        tools: tools.map(exports.normalizeTool),
        isNew: Boolean(agent === null || agent === void 0 ? void 0 : agent.isNew),
    };
};
exports.buildAgentPayload = function (agentDraft) {
    var _a, _b, _c, _d, _e, _f;
    var agentSettings = (agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.role) === 'faq'
        ? {}
        : exports.normalizeAgentSettings(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.agentSettings);
    var payload = {
        name: (_a = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.name) !== null && _a !== void 0 ? _a : '',
        llm_provider: (_b = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.modelProvider) !== null && _b !== void 0 ? _b : '',
        llm_model: (_c = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.model) !== null && _c !== void 0 ? _c : '',
        is_default: Boolean(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.isDefault),
        date_time_context_enabled: Boolean(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.enableDateTimeContext),
        instructions: (_d = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.instructions) !== null && _d !== void 0 ? _d : '',
        language_specific_instructions: (_e = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.languageSpecificInstructions) !== null && _e !== void 0 ? _e : {},
        role: (_f = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.role) !== null && _f !== void 0 ? _f : 'specialist',
        deleted_tool_ids: Array.isArray(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.deletedToolIds)
            ? agentDraft.deletedToolIds
            : [],
        common_tool_ids: exports.normalizeCommonToolIds(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.commonToolIds),
        agent_settings: agentSettings,
        tools: Array.isArray(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.tools)
            ? agentDraft.tools.map(exports.serializeVoiceAgentTool)
            : [],
    };
    return payload;
};
exports.trimAgentDraft = function (agentDraft) {
    if (!agentDraft || typeof agentDraft !== 'object')
        return agentDraft;
    var trimmedLanguageSpecificInstructions = Object.entries((agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.languageSpecificInstructions) || {}).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return acc;
    }, {});
    var trimmedAgentSettings = Object.entries(exports.normalizeAgentSettings(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.agentSettings)).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return acc;
    }, {});
    var trimmedTools = Array.isArray(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.tools)
        ? agentDraft.tools.map(exports.trimVoiceAgentTool)
        : [];
    return __assign(__assign({}, agentDraft), { name: ((agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.name) || '').toString().trim(), modelProvider: agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.modelProvider, model: agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.model, instructions: ((agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.instructions) || '').toString().trim(), languageSpecificInstructions: trimmedLanguageSpecificInstructions, agentSettings: trimmedAgentSettings, commonToolIds: exports.normalizeCommonToolIds(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.commonToolIds), tools: trimmedTools });
};
